import { connect, NatsConnection, JSONCodec, ConnectionOptions } from "nats.ws"
import type { TNatsCreds } from "types/nats.type"

export class NatsService {
	private nc: NatsConnection | null = null
	private jc = JSONCodec()
	private closing = false

	async connect(servers: string, natsCreds: TNatsCreds): Promise<void> {
		const connectionOptions: ConnectionOptions = {
			servers: servers,
			waitOnFirstConnect: true,
			user: natsCreds.username,
			pass: natsCreds.password,
		}
		this.nc = await connect(connectionOptions)
	}

	subscribe<T>(subject: string, callback: (message: T, subject: string) => void) {
		if (!this.nc) {
			console.error("NATS connection is not established.")
			return
		}

		return this.nc.subscribe(subject, {
			callback: (e, msg) => {
				if (e) {
					console.error("Error in subscription:", e)
					return
				}
				const message = this.jc.decode(msg.data) as T
				callback(message, msg.subject)
			},
		})
	}

	async close() {
		if (this.nc && !this.closing) {
			this.closing = true
			await this.nc.drain()
			this.nc = null
			this.closing = false
		}
	}
}
